// src/renderer/blocks/ImageBlock.js
import React from 'react';
import { evalBinding } from '../../lib/bindings';

/**
 * Image block
 * {
 *   "type": "image",
 *   "src": { "path": "header.profileIconUrl" }, // Binding
 *   "alt": "Profile",
 *   "width": 32, "height": 32,
 *   "className": "me-2"
 * }
 */
export default function ImageBlock({ block, data }: any) {
  const src = block.src ? evalBinding(block.src, data) : null;
  if (!src) return null;

  const { alt = '', width, height, className } = block;
  const style = {
    ...(block.style || {}),
    ...(width ? { width } : {}),
    ...(height ? { height } : {})
  };

  return <img src={src} alt={alt} className={className || ''} style={style} />;
}
